import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api, { formatApiError, setTabCompany } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setTabCompany(data?.active_company_id || "");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      setTabCompany("");
      const { data } = await api.post("/auth/login", { email, password });
      await refresh();
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const switchCompany = async (companyId) => {
    await api.post(`/auth/switch-company/${companyId}`);
    setTabCompany(companyId);
    // Full reload so every page refetches the new company's data.
    window.location.assign("/dashboard");
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed", e);
    }
    setTabCompany("");
    setUser(null);
  };

  const value = useMemo(() => ({ user, login, logout, refresh, switchCompany }), [user, refresh]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
